import React from 'react';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { hexToRGB } from 'utils';
import styled from 'styled-components';
import { Text, RowDiv } from 'styles';
import { BOARD_NOTICE_MODULE_NO, BOARD_QNA_MODULE_NO, BOARD_ARCHIVE_MODULE_NO } from 'data/constants';
import { Icon } from './Icon';
import { Download } from './Download';

// label: 전용 게시판(공지/Q&A/자료실)이 아닌 관리자 추가 게시판은 게시판명을 넘겨 같은 자리에 표시
export function NoticeList({ list, downloadLabel, onClick, hideUserName , hideDownloadFile, label, ...props }) {
  const { t } = useTranslation();

  return (
    list && (
      <List $type={props.type}>
        {list.map((item) => (
          <ListItem key={`item_${item.contentNo}`} onClick={() => onClick(item)}>
            <div>
              <Text $color="primary" $mFontSize={11}>
                {item.moduleNo === BOARD_NOTICE_MODULE_NO && t('공지사항').toUpperCase()}
                {item.moduleNo === BOARD_QNA_MODULE_NO && t('Q&A').toUpperCase()}
                {item.moduleNo === BOARD_ARCHIVE_MODULE_NO && t('자료실').toUpperCase()}
                {label &&
                  item.moduleNo !== BOARD_NOTICE_MODULE_NO &&
                  item.moduleNo !== BOARD_QNA_MODULE_NO &&
                  item.moduleNo !== BOARD_ARCHIVE_MODULE_NO &&
                  label}
              </Text>
            </div>
            <RowDiv $gap={item.useSecret && 4}>
              <Text $type="h5" $maxLine={1} $mType="h6">
                {item.title}
              </Text>
              {item.useSecret && <Icon name="lock" $width={24} $height={24} $padding="0" />}
            </RowDiv>
            <RowDiv $height="100%" $alignItems="center" $mGap={16}>
              { !hideUserName && item.regUserName && (
                <RowDiv
                  $maxWidth={133}
                  $minWidth={123}
                  $mMaxWidth="unset"
                  $width="100%"
                  $mWidth="unset"
                  $justifyContent="center"
                  $mJustifyContent="start"
                  $mPadding="7px 8px"
                  $mMinWidth={44}
                >
                  <Text $color={hexToRGB('#171717', 0.4)} $fontWeight={500} $mType="h8">
                    {item.regUserName}
                  </Text>
                </RowDiv>
              )}
              { !hideDownloadFile && item.attachFiles && item.attachFiles.length > 0 && (
                <Download siteFileId={item.attachFiles[0].siteFileId} filename={item.attachFiles[0].originalFileName}>
                  <FileBox>
                    <Icon name="download" $width={20} $height={20} $padding="1px" />
                    <Text $color="primary" $type="b7" $fontWeight={500}>
                      {downloadLabel}
                    </Text>
                  </FileBox>
                </Download>
              )}
              <RowDiv $alignItems="center" $height="100%">
                <Icon name="clock" $width={14} $height={14} />
                <Text $color={hexToRGB('#171717', 0.4)} $fontWeight={500} $mType="b8">
                  {item.regDate ? dayjs(item.regDate).format(t('date_format')) : ''}
                </Text>
              </RowDiv>
            </RowDiv>
          </ListItem>
        ))}
      </List>
    )
  );
}

const List = styled.ul`
  width: 100%;
  ${({ $type }) => $type !== 'qna' && `margin-top:24px`};

  @media ${({ theme }) => theme.device.mobile} {
    margin-top: 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
`;

const ListItem = styled.li`
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 126px;
  transition: all 150ms ease;
  border-bottom: 1px solid ${({ theme }) => hexToRGB(theme.colors.strong, 0.12)};
  text-align: center;

  & > div:nth-child(1) {
    max-width: 145px;
    width: 100%;
  }

  & > div:nth-child(2) {
    text-align: start;
    flex: 6;
    padding: 0 48px;
    align-items: center;
  }

  @media ${({ theme }) => theme.device.mobile} {
    flex-direction: column;
    align-items: flex-start;
    height: fit-content;
    text-align: start;

    & > div:nth-child(1) {
      padding: 4px 11px;
    }
    & > div:nth-child(2) {
      padding: 8px 11px;
      flex: unset;
    }
    & > div:nth-last-child(1) {
      padding: 4px 8px 16px;
      align-items: center;
      justify-content: flex-start;
    }
  }
`;

const FileBox = styled(RowDiv)`
  min-width: 133px;
  width: 100%;
  height: 100%;
  gap: 8px;
  align-items: center;
  justify-content: center;

  @media ${({ theme }) => theme.device.mobile} {
    min-width: unset;
  }
`;
